import React, { Fragment } from "react";
import { Footerlight, PageLayout } from "../../../Constant";
import StbListContainer from "./StbList";

const StbModem = () => {
    return (
        <Fragment>
            <StbListContainer mainTitle={Footerlight} title={Footerlight} parent={PageLayout} />  
        </Fragment>
    )
}
export default StbModem;